export default "__VITE_ASSET__Bhsux0Bg__"